import React from 'react';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import env from 'env';
import { lazyLoad } from 'utils/loadable';

import { messages } from '../modules/translation';

import { useLayoutStore } from './store';
const PrintingComponent: React.FC<any> = (props) => {
  const spinnerOpen = useLayoutStore((state) => state.spinnerOpen);
  return (
    <>
      <LoadingOverlay active={spinnerOpen} spinner text={messages('pleaseWait')}>
        <div className="wrapper d-flex flex-column">
          <div className="flex-fill">
            <div className="container content-body" style={{ marginTop: 88 }}>
              {props.children}
            </div>
          </div>

          <footer className="footer pt-3 pb-1 mt-5">
            <div className="container">
              <div>
                <div className="img-fluid mx-auto mb-2 footerLogo">
                  {env.version && <h6 className="font-weight-bold float-right">{env.version}</h6>}
                </div>
              </div>
            </div>
          </footer>
        </div>
      </LoadingOverlay>
    </>
  );
};

export const Printing = React.memo(PrintingComponent);

export const PrintingLayout = lazyLoad(
  () => import('../layouts/printing'),
  (module) => module.Printing
);
